module.exports = __webpack_public_path__ + "static/media/referral_48.e94c1872.png";